"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactSlick = _interopRequireDefault(require("react-slick"));

var _reactRouterDom = require("react-router-dom");

var _CarouselArrow = require("../../../../common/components/CarouselArrow");

var _Elements = require("../../Elements");

var _Elements2 = require("../../../../Elements");

var _helpers = require("../../../../../../lib/helpers");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var FolderCarousel = function FolderCarousel(_ref) {
  var portfolio = _ref.portfolio,
      folders = _ref.folders,
      isTabletPortrait = _ref.isTabletPortrait,
      isTypeTheme = _ref.isTypeTheme,
      vh1 = _ref.vh1,
      sliderIndex = _ref.sliderIndex,
      setSliderIndex = _ref.setSliderIndex,
      webpSupported = _ref.webpSupported,
      publicUrl = _ref.publicUrl;
  var imageRef = (0, _react.useRef)(null);
  var sliderRef = (0, _react.useRef)(null);

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      enterPressed = _useState2[0],
      setEnterPressed = _useState2[1];

  var history = (0, _reactRouterDom.useHistory)();

  var keyDownHandler = function keyDownHandler(event) {
    var _sliderRef$current, _sliderRef$current2;

    switch (event.code) {
      case 'ArrowRight':
        event.preventDefault();
        event.stopPropagation(); // eslint-disable-next-line no-unused-expressions

        sliderRef === null || sliderRef === void 0 ? void 0 : (_sliderRef$current = sliderRef.current) === null || _sliderRef$current === void 0 ? void 0 : _sliderRef$current.slickNext();
        break;

      case 'ArrowLeft':
        event.preventDefault();
        event.stopPropagation(); // eslint-disable-next-line no-unused-expressions

        sliderRef === null || sliderRef === void 0 ? void 0 : (_sliderRef$current2 = sliderRef.current) === null || _sliderRef$current2 === void 0 ? void 0 : _sliderRef$current2.slickPrev();
        break;

      case 'Enter':
        event.preventDefault();
        event.stopPropagation();
        setEnterPressed(true);
        break;

      default:
        break;
    }
  };

  (0, _react.useEffect)(function () {
    window.addEventListener('keydown', keyDownHandler);
    return function () {
      window.removeEventListener('keydown', keyDownHandler);
    };
  }, []);
  (0, _react.useEffect)(function () {
    if (enterPressed) {
      var folder = folders === null || folders === void 0 ? void 0 : folders[sliderIndex];
      history.push("".concat(publicUrl, "/gallery/").concat(folder.id));
      setEnterPressed(false);
    }
  }, [enterPressed]);
  var settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow: sliderIndex === 0 ? null : /*#__PURE__*/_react["default"].createElement(_CarouselArrow.PrevArrow, {
      transparentBg: false,
      colour: portfolio === null || portfolio === void 0 ? void 0 : portfolio.colour,
      offset: 48
    }),
    nextArrow: sliderIndex === folders.length - 1 ? null : /*#__PURE__*/_react["default"].createElement(_CarouselArrow.NextArrow, {
      transparentBg: false,
      colour: portfolio === null || portfolio === void 0 ? void 0 : portfolio.colour,
      offset: 48
    })
  };
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, isTabletPortrait && /*#__PURE__*/_react["default"].createElement(_Elements.SliderBox, {
    ref: imageRef
  }, /*#__PURE__*/_react["default"].createElement(_reactSlick["default"], (0, _extends2["default"])({}, settings, {
    ref: sliderRef,
    afterChange: function afterChange(index) {
      setSliderIndex(index);
    },
    onInit: function onInit() {
      setSliderIndex(0);
    }
  }), folders.map(function (folder) {
    var _folder$coverPhoto;

    return /*#__PURE__*/_react["default"].createElement(_Elements.SliderItemBox, {
      key: folder.id,
      isTabletPortrait: isTabletPortrait,
      isTypeTheme: isTypeTheme,
      vh1: vh1
    }, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, {
      to: "".concat(publicUrl, "/gallery/").concat(folder.id)
    }, /*#__PURE__*/_react["default"].createElement(_Elements.Image, {
      onContextMenu: function onContextMenu(e) {
        return e.preventDefault();
      },
      src: (0, _helpers.getImageByFormat)((_folder$coverPhoto = folder.coverPhoto) === null || _folder$coverPhoto === void 0 ? void 0 : _folder$coverPhoto.images[0], webpSupported)
    }), /*#__PURE__*/_react["default"].createElement(_Elements.Mask, {
      isTabletPortrait: isTabletPortrait,
      isTypeTheme: isTypeTheme,
      vh1: vh1
    }, /*#__PURE__*/_react["default"].createElement(_Elements2.PortfolioHeadline, {
      white: true,
      singleLineText: true,
      style: {
        maxWidth: 480
      }
    }, folder.name), folder.description && /*#__PURE__*/_react["default"].createElement(_Elements2.PortfolioParagraph, {
      mt: "xs",
      white: true,
      center: true,
      style: {
        maxWidth: 480
      },
      singleLineText: true
    }, folder.description))));
  }))), !isTabletPortrait && folders.map(function (folder) {
    var _folder$coverPhoto2;

    return /*#__PURE__*/_react["default"].createElement(_Elements.HomeListItemBox, {
      key: folder.id,
      mb: "xs"
    }, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, {
      to: "".concat(publicUrl, "/gallery/").concat(folder.id)
    }, /*#__PURE__*/_react["default"].createElement(_Elements.HomeListItemImg, {
      ref: imageRef,
      src: (0, _helpers.getImageByFormat)((_folder$coverPhoto2 = folder.coverPhoto) === null || _folder$coverPhoto2 === void 0 ? void 0 : _folder$coverPhoto2.images[0], webpSupported),
      onContextMenu: function onContextMenu(e) {
        return e.preventDefault();
      }
    }), /*#__PURE__*/_react["default"].createElement(_Elements.HomeListItemMask, null, /*#__PURE__*/_react["default"].createElement(_Elements2.PortfolioHeadline, {
      white: true,
      singleLineText: true,
      style: {
        maxWidth: 343
      }
    }, folder.name), folder.description && /*#__PURE__*/_react["default"].createElement(_Elements2.PortfolioParagraph, {
      mt: "xxs",
      white: true,
      center: true,
      style: {
        maxWidth: 343
      },
      singleLineText: true
    }, folder.description))));
  }));
};

FolderCarousel.propTypes = {
  portfolio: _propTypes["default"].shape().isRequired,
  folders: _propTypes["default"].arrayOf(_propTypes["default"].shape()),
  isTabletPortrait: _propTypes["default"].bool.isRequired,
  isTypeTheme: _propTypes["default"].bool.isRequired,
  vh1: _propTypes["default"].number.isRequired,
  sliderIndex: _propTypes["default"].number.isRequired,
  setSliderIndex: _propTypes["default"].func.isRequired,
  webpSupported: _propTypes["default"].bool.isRequired,
  publicUrl: _propTypes["default"].string.isRequired
};
FolderCarousel.displayName = 'FolderCarousel';
var _default = FolderCarousel;
exports["default"] = _default;